import * as ActionAuth from '../Store/AuthAction';
import * as ActionComponent from '../../App/Store/ComponentAction';
import * as SelectorsComponent from '../../App/Selector/AppSelector';

import { bindActionCreators, compose } from 'redux';

import ModalChangePasswordComponent from '../Component/ModalChangePasswordComponent';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getFormSyncErrors } from 'redux-form';

function ModalUserChangePasswordContainer(props) {
  const { componentAction, authAction } = props;

  const handleCancel = () => {
    componentAction.openModal('ChangePassword');
    authAction.resetForm();
  };

  const handleSubmit = e => {
    e.preventDefault();
    authAction.submitChangePassword();
  };

  return (
    <ModalChangePasswordComponent
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      {...props}
    />
  );
}

const mapStateToProps = createStructuredSelector({
  loading: SelectorsComponent.makeIsLoading(),
  changePassword: SelectorsComponent.changePasswordModalIsShow(),
  errorFormValue: getFormSyncErrors('changePasswordForm'),
});

const mapDispatchToProps = dispatch => ({
  authAction: bindActionCreators(ActionAuth, dispatch),
  componentAction: bindActionCreators(ActionComponent, dispatch),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(ModalUserChangePasswordContainer);
